
import { Component, Vue, Watch } from "vue-property-decorator";
import BodyComponent from "./components/body.vue";
import HeaderComponent from "./components/header.vue";

interface TourStep {
  target: string,
  content: string,
  params?: {
    placement?: string
  }
}

@Component({
  components: {
    "cust-header": HeaderComponent,
    "cust-body": BodyComponent,
  }
})
export default class App extends Vue {
  urlConfig!: any
  urlConfigImportConfirmationDialog: boolean = false
  tourDialog: boolean = !this.tourTaken
  tourSteps: Array<TourStep> = [
    {
      target: '#v-step-time',
      content: `This section contains some timestamps, as in the top screens in Mission Control. Hover over the them to get some details.`
    },{
      target: '#v-step-menu',
      content: `Here are you can find some more options. For example to enable editing the tiles shown below.`
    },{
      target: '#v-step-nasatv',
      content: `Here you can find the current schedule for NASA+ live events.`
    },{
      target: '#v-step-spacestationblog',
      content: `Here you can find some blog entries of NASA's SpaceStation blog.`
    },{
      target: '#v-step-help + button',
      content: `If you see a question mark like this, you can get some help or context. Especially helpful when editing a tile.<br />That wraps up the small tour. Have fun using this page!`
    }
  ]

  get tourTaken() {
    return this.$store.getters['config/getTourTaken']()
  }

  get fullscreenState() {
    return this.$store.getters["fullscreenState"];
  }

  mounted() {
    document.onfullscreenchange = (ev) => {
      if (this.fullscreenState !== (document.fullscreenElement !== null)) {
        this.$store.dispatch("toggleFullscreen");
      }
    }

    let configMatch = document.location.hash.match(/[#&]config=(?<config>[^&]*)/)
    if (configMatch && configMatch.groups && configMatch.groups.config) {
      this.urlConfig = JSON.parse(decodeURIComponent(configMatch.groups.config))
      this.urlConfigImportConfirmationDialog = true
    }
  }

  closeTourDialog() {
    this.tourDialog = false;
    this.$store.dispatch('config/updateTourTaken', true)
  }

  importConfigFromUrl(save?: boolean) {
    if (save && this.urlConfig) {
      this.$store.dispatch("config/updateAllConfig", this.urlConfig)
    }
    window.location.hash = ""
    this.urlConfigImportConfirmationDialog = false
  }

  @Watch("fullscreenState")
  watchFullscreenState(value: boolean) {
    if (value !== (document.fullscreenElement !== null)) {
      let app = document.getElementById("app");
      if (app) {
        if (value) {
          app.requestFullscreen();
        } else {
          document.exitFullscreen();
        }
      }
    }
  }
}
